import { View, ViewStyle } from "react-native";
import { SafeAreaProps } from "./types";
import { useSafeArea } from "./useSafeArea";

const SafeArea = ({
	children,
	ignoreBottom,
	ignoreLeft,
	ignoreRight,
	ignoreTop,
	style,
}: SafeAreaProps) => {
	const safeArea = useSafeArea();
	return (
		<View
			style={[
				{
					flex: 1,
				},
				style,
				{
					paddingBottom:
						(ignoreBottom ? 0 : safeArea.bottom) +
						(((style as ViewStyle)?.paddingBottom ?? 0) as number),
					paddingLeft:
						(ignoreLeft ? 0 : safeArea.left) +
						(((style as ViewStyle)?.paddingLeft ?? 0) as number),
					paddingRight:
						(ignoreRight ? 0 : safeArea.right) +
						(((style as ViewStyle)?.paddingRight ?? 0) as number),
					paddingTop:
						(ignoreTop ? 0 : safeArea.top) +
						(((style as ViewStyle)?.paddingTop ?? 0) as number),
				},
			]}
		>
			{children}
		</View>
	);
};
export default SafeArea;
